import React from 'react';
import s from './static/s.png';

function App() {
  return (
    <div className="App">
      <div className="container">
        <img src={s}></img>
        <p>
          <br />
          @sepezho
          <br />
          ------------
          <br />
          software engineer: crypto + ai 
          <br />
          projects: <a href="https://coffer.so">coffer</a>, <a href="https://evaa.finance">evaa</a>, <a href="https://stx.tg">stx</a>, <a href="https://toncells.org">cells</a> 
          <br />
          ex <a href="https://ton.org">ton</a> foundation
          <br />
          ------------
          <nav>
            <li>
              my <a href="https://sepezho.t.me">telegram</a>
            </li>
            <li>
              main tg <a href="https://sepezho_log.t.me">channel</a>
            </li>
            <li>
              live tg <a href="https://sepezholive.t.me">channel</a>
            </li>
            <li>
              my <a href="https://x.com/sepezho">twitter</a>
            </li>
            <li>
              youtube <a href="https://www.youtube.com/@sepezho">channel</a>
            </li>
            <li>
              me on <a href="https://github.com/sepezho">github</a>
            </li>
          </nav>
        </p>
      </div >
    </div >
  );
}

export default App;
